import { Translatable } from "@icc/shared/helpers";

/** Uchwyt ścienny */
export class WallMount {
    id: number;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    description: string;
    img: string;
    lamellaIds: number[];
    blindGuidanceIds: number[];
    /** Liczba uchwytów */
    amount?: number;
    printCode?: string;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
}